import { render, staticRenderFns } from "./OrganizationList.vue?vue&type=template&id=1a3d2a72&scoped=true&xmlns%3Abackground-color=http%3A%2F%2Fwww.w3.org%2F1999%2Fxhtml"
import script from "./OrganizationList.vue?vue&type=script&lang=js"
export * from "./OrganizationList.vue?vue&type=script&lang=js"
import style0 from "./OrganizationList.vue?vue&type=style&index=0&id=1a3d2a72&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3d2a72",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a3d2a72')) {
      api.createRecord('1a3d2a72', component.options)
    } else {
      api.reload('1a3d2a72', component.options)
    }
    module.hot.accept("./OrganizationList.vue?vue&type=template&id=1a3d2a72&scoped=true&xmlns%3Abackground-color=http%3A%2F%2Fwww.w3.org%2F1999%2Fxhtml", function () {
      api.rerender('1a3d2a72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/OrganizationList.vue"
export default component.exports